import { classes } from 'html-classes';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import styles from './Buttons.module.scss';

const ShopButton = () => {
  const { t } = useTranslation();

  return (
    <Link to="/shop" className={classes([styles.shop, 'button _secondary'])}>
      {t('loyalty:buttons:shop')}
    </Link>
  );
};

export default ShopButton;
